<template>
  <div class="relabel-job-row">
    <div class="relabel-job-row__main">
      <div class="text-body-2 font-weight-medium">
        {{ $t('myboxes.relabel_jobs.change_to', { label: targetLabel }) }}
      </div>
      <div class="text-caption text-medium-emphasis">{{ createdAt }}</div>

      <div v-if="filterCriteria.length > 0" class="relabel-job-row__filters mt-2">
        <div class="text-overline mb-1">{{ $t('myboxes.relabel_jobs.filter') }}</div>
        <ul class="relabel-job-row__filter-list mb-0">
          <li v-for="(criterion, index) in filterCriteria" :key="index">
            <span class="font-weight-medium">{{ criterion.label }}:</span>
            {{ criterion.value }}
          </li>
        </ul>
      </div>
    </div>

    <div class="relabel-job-row__status">
      <template v-if="queued">
        <v-chip size="x-small" variant="outlined" color="grey">
          {{ $t('myboxes.relabel_jobs.waiting') }}
        </v-chip>
      </template>
      <template v-else>
        <v-progress-linear
          :model-value="job.progress || 0"
          height="8"
          rounded
          color="primary"
          class="mb-1"
        />
        <div class="text-caption text-center">
          {{ Math.round(job.progress || 0) }}%
          <span v-if="progressText"> · {{ progressText }}</span>
        </div>
      </template>

      <v-btn
        v-if="canCancel"
        size="small"
        variant="text"
        color="error"
        class="mt-2"
        :loading="cancelling"
        @click="cancelJob"
      >
        {{ $t('myboxes.relabel_jobs.cancel') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import {
  formatFilterCriteria,
  parseJobDescription,
  progressLabel,
} from '@/components/myboxes/relabelInFilterJobUtils';

export default {
  name: 'RelabelInFilterJobRow',
  props: {
    job: { type: Object, required: true },
    filterOptions: { type: Array, default: () => [] },
    queued: { type: Boolean, default: false },
  },
  data() {
    return {
      cancelling: false,
    };
  },
  computed: {
    description() {
      return parseJobDescription(this.job);
    },
    targetLabel() {
      return this.description.label || '—';
    },
    filterCriteria() {
      return formatFilterCriteria(this.description.filters, this.filterOptions);
    },
    progressText() {
      return progressLabel(this.job);
    },
    createdAt() {
      return this.job.created_at || '';
    },
    canCancel() {
      return this.job.processed === 0 && !this.job.deleted_at;
    },
  },
  methods: {
    async cancelJob() {
      if (!window.confirm(this.$t('myboxes.relabel_jobs.cancel_confirm'))) {
        return;
      }
      this.cancelling = true;
      try {
        await this.$api.job.delete(this.job);
        this.$emit('cancelled');
      } finally {
        this.cancelling = false;
      }
    },
  },
};
</script>

<style scoped>
.relabel-job-row {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding: 12px 0;
}

.relabel-job-row + .relabel-job-row {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.relabel-job-row__main {
  flex: 1;
  min-width: 0;
}

.relabel-job-row__status {
  flex-shrink: 0;
  width: 120px;
  text-align: center;
}

.relabel-job-row__filter-list {
  padding-left: 18px;
}
</style>
